import {
  ACTIVE_USERS,
  ACTIVE_USERS_ADDED,
  CATALOG_TOTAL_METRIC,
  COLLECTION_REFERENCES,
  CURRENT_CUSTOM_EVENTS_STORED,
  CURRENT_USERS,
  CUSTOM_EVENTS_STORED,
  EMAILS_SENT,
  IN_APP_NOTIFICATIONS_SENT,
  JVT_COUNT,
  LOOKUP_REFERENCES,
  MMS_ATTACHMENTS_RECEIVED,
  MMS_ATTACHMENTS_SENT,
  MMS_ATTACHMENTS_TOTAL,
  PRODUCT_RECOMMENDATIONS,
  PUSH_NOTIFICATIONS_SENT,
  SMART_INGEST_METRICS,
  SMS_SEGMENTS_RECEIVED,
  SMS_SEGMENTS_SENT,
  SMS_SEGMENTS_TOTAL,
  SMS_SENT,
  SUCCESSFUL_SMS_VERIFICATIONS,
  TOTAL_CUSTOM_EVENTS_HIGH_WATERMARK,
  TOTAL_USERS_HIGH_WATERMARK,
  USERS,
  USERS_ADDED,
  WEB_PUSH_NOTIFICATIONS_SENT,
  WHATSAPP_SENT,
} from './metricNames';

export const LABELS_BY_METRIC_NAME = {
  [EMAILS_SENT]: 'Emails sent',
  [SMS_SENT]: 'SMS sent',
  [PUSH_NOTIFICATIONS_SENT]: 'Push sent',
  [WEB_PUSH_NOTIFICATIONS_SENT]: 'Web push sent',
  [IN_APP_NOTIFICATIONS_SENT]: 'In-app sent',
  [SMS_SEGMENTS_SENT]: 'SMS segments sent',
  [SMS_SEGMENTS_TOTAL]: 'SMS segments total',
  [SMS_SEGMENTS_RECEIVED]: 'SMS segments received',
  [MMS_ATTACHMENTS_TOTAL]: 'MMS total',
  [MMS_ATTACHMENTS_RECEIVED]: 'MMS received',
  [MMS_ATTACHMENTS_SENT]: 'MMS sent',
  [SUCCESSFUL_SMS_VERIFICATIONS]: 'SMS verifications',
  [CATALOG_TOTAL_METRIC]: 'Catalog references',
  [LOOKUP_REFERENCES]: 'Lookup references',
  [COLLECTION_REFERENCES]: 'Collection references',
  [PRODUCT_RECOMMENDATIONS]: 'Product recommendations',
  [CURRENT_CUSTOM_EVENTS_STORED]: 'Current',
  [CUSTOM_EVENTS_STORED]: 'Custom events stored',
  [TOTAL_CUSTOM_EVENTS_HIGH_WATERMARK]: 'High water mark',
  [USERS]: 'User count',
  [CURRENT_USERS]: 'Current',
  [USERS_ADDED]: 'Users added',
  [TOTAL_USERS_HIGH_WATERMARK]: 'High water mark',
  [ACTIVE_USERS]: 'Active users',
  [ACTIVE_USERS_ADDED]: 'Active users added',
  [SMART_INGEST_METRICS.productionSyncsCount]: 'Production syncs',
  [SMART_INGEST_METRICS.testSyncsCount]: 'Test syncs',
  [JVT_COUNT]: 'Total events tracked',
  [WHATSAPP_SENT]: 'WhatsApp sent',
};

export const JOURNEY_NAME_COLUMN_LABEL = 'Journey';
export const JOURNEY_NAME_COLUMN_VALUE = 'journeyId';
